import React, { useState, useEffect } from 'react';
import moment from 'moment';

import EventsCardList from '../../../Events/EventsDisplay/eventsCardList';
import { getEventsListByEventType, EventTypes, isClubAdminOrOwner, isProCollegeClubAdminOrOwner, isFreeCollegeClubOwnerOrAdmin } from '../../../../utils/clubs';
import { EventHsTypes, EventScheduleTypes } from '../../../../utils/eventConstants';

const ScheduleTabContent = (props) => {
    const { RECENT, UPCOMING } = EventScheduleTypes;
    const {
        clubDetails,
        auth,
        eventsTypeName,
        tmsEventsFetchState,
        fetchClubTMSEventsList,
        isAdminOrOwner,
        onTeamMatchMenuSelected,
        onCreateEventClick,
        highSchoolStandingsSeasons,
        getHighSchoolStandingsSeasons,
        collegeDualMatchFlagEnabled,
    } = props;
    const upcomingTeamEvents = clubDetails && getEventsListByEventType(clubDetails, UPCOMING, EventTypes.TEAM_MATCHES, null, clubDetails.tierType.isHighSchool ? EventHsTypes.OFFICIAL : null);
    let recentTeamEvents = clubDetails?.tierType?.isHighSchool === false ? clubDetails && getEventsListByEventType(clubDetails, RECENT, EventTypes.TEAM_MATCHES, tmsEventsFetchState) : [];
    const totalTMSEventsCount = clubDetails && isClubAdminOrOwner(clubDetails) ? clubDetails.tmsEventsCount + clubDetails.demoEventCount : clubDetails.tmsEventsCount;

    const officialHsEventCount = clubDetails.officialHsEventCount || 0;
    const totalOfficialHsEventCount = clubDetails?.tierType.isHighSchool && isClubAdminOrOwner(clubDetails) ? clubDetails.officialHsDemoEventCount || 0 : 0;
    const eventCount = clubDetails.tierType.isHighSchool ? officialHsEventCount + totalOfficialHsEventCount : totalTMSEventsCount;
    const eventsFetched = clubDetails.tierType.isHighSchool ? tmsEventsFetchState.officialHsEventsFetched : tmsEventsFetchState.eventsFetched;

    const [selectedSeason, setSelectedSeason] = useState(null);

    const hasPermission = isProCollegeClubAdminOrOwner(clubDetails) || isFreeCollegeClubOwnerOrAdmin(clubDetails);
    const canPerformActions = collegeDualMatchFlagEnabled && clubDetails.tierType.isCollege ? hasPermission : isAdminOrOwner;

    if (clubDetails.tierType.isHighSchool) {
        recentTeamEvents = clubDetails && getEventsListByEventType(clubDetails, RECENT, EventTypes.TEAM_MATCHES, tmsEventsFetchState, EventHsTypes.OFFICIAL);
    }

    useEffect(() => {
        getHighSchoolStandingsSeasons({ clubId: clubDetails.id });
    }, []);

    useEffect(() => {
        if (highSchoolStandingsSeasons.length > 0) {
            setSelectedSeason(highSchoolStandingsSeasons[0]);
        }
    }, [highSchoolStandingsSeasons]);

    const handleSeasonChange = (e) => {
        setSelectedSeason(parseInt(e.target.value));
    };

    const getSeasonYearDisplay = (year) => {
        return `${year} - ${(year % 1000) + 1}`;
    };

    const filterBySeason = (event) => {
        if (event.momentStartDate && moment(event.momentStartDate).isBetween(`${selectedSeason}-07-01`, `${selectedSeason + 1}-06-30`)) {
            return true;
        }
        return false;
    };

    const showSeasonFilter = (clubDetails?.tierType?.isHighSchool && clubDetails?.schoolProfile);

    return (
        <>
            {showSeasonFilter && (
                <div className={`row`}>
                    <div className={`col-md-12`}>
                        <h6 className="text-uppercase">
                            <div className="form-inline mb16">
                                <div className={`d-flex align-items-center justify-content-center`}>
                                    <label className="text-uppercase mt12 mr16">Season</label>
                                    <div className="input-wrapper mr8">
                                        <select
                                            className="form-control form-control-sm"
                                            value={selectedSeason}
                                            onChange={handleSeasonChange}
                                        >
                                            {highSchoolStandingsSeasons?.length && (
                                                <>
                                                    {highSchoolStandingsSeasons.map(season => {
                                                        return <option key={season} value={season}>{getSeasonYearDisplay(season)}</option>;
                                                    })}
                                                </>
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </h6>
                    </div>
                </div>
            )}
            <div className={`row`}>
                <div className={`col-md-12`}>
                    <h6 className="text-uppercase">
                        {`Upcoming ${eventsTypeName}`}
                    </h6>
                </div>
            </div>
            <div className={`row`}>
                <div className={`col-md-12`}>
                    <EventsCardList
                        listTypeName={`upcoming`}
                        events={showSeasonFilter ? upcomingTeamEvents.filter(filterBySeason) : upcomingTeamEvents}
                        auth={auth}
                        clubName={clubDetails.name}
                        clubId={clubDetails.id}
                        limit={true}
                        showAllLinkVisible={false}
                        eventsTypeName={eventsTypeName}
                        isAdminOrOwner={isAdminOrOwner || canPerformActions}
                        showAdminOptions={isAdminOrOwner || canPerformActions}
                        isCollege={clubDetails.tierType.isCollege}
                        onCreateEventClick={onCreateEventClick}
                        onTeamMatchMenuSelected={onTeamMatchMenuSelected}
                    />
                </div>
            </div>
            {recentTeamEvents && (recentTeamEvents.length > 0) && (
                <>
                    <div className={`row`}>
                        <div className={`col-md-12`}>
                            <h6 className="text-uppercase">
                                {`Past ${eventsTypeName}`}
                            </h6>
                        </div>
                    </div>
                    <div className={`row`}>
                        <div className={`col-md-12`}>
                            <EventsCardList
                                listTypeName={`recent`}
                                events={showSeasonFilter ? recentTeamEvents.filter(filterBySeason) : recentTeamEvents}
                                auth={auth}
                                clubName={clubDetails.name}
                                clubId={clubDetails.id}
                                limit={false}
                                showAllLinkVisible={false}
                                eventsTypeName={eventsTypeName}
                                isAdminOrOwner={isAdminOrOwner || canPerformActions}
                                showAdminOptions={isAdminOrOwner || canPerformActions}
                                isCollege={clubDetails.tierType.isCollege}
                                onTeamMatchMenuSelected={onTeamMatchMenuSelected}
                                onCreateEventClick={onCreateEventClick}
                            />
                        </div>
                        {!tmsEventsFetchState.eventsListExhausted && (eventsFetched < eventCount) && (
                            <div className="col">
                                <button
                                    type="button"
                                    className="btn btn-default btn-xl mt16"
                                    onClick={() => (clubDetails.tierType.isHighSchool ? fetchClubTMSEventsList(null, EventHsTypes.OFFICIAL, null, null, true) : fetchClubTMSEventsList())}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default ScheduleTabContent;
